var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypageHospital = function SvgMypageHospital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD267",
    d: "M18.862 15.635a3.639 3.639 0 0 0 0-7.275h-3.221V5.138a3.636 3.636 0 1 0-7.276 0v10.497z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M15.635 18.862a3.639 3.639 0 0 1-7.275 0v-3.221H5.138a3.638 3.638 0 1 1 0-7.276h10.497z"
  })));
};
export default SvgMypageHospital;